"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DependencyInjector_1 = require("./Utility/DependencyInjector");
const App_1 = require("./App");
(0, DependencyInjector_1.setFetch)(window.fetch.bind(window));
exports.default = new App_1.default();
//# sourceMappingURL=index.js.map